import { useState } from "react";
import { useSnackbar } from "notistack";
import { useApolloClient } from "@apollo/client";
import { Box, Paper, Typography } from "@mui/material";
import { classes } from "@/admin/shared/ui/StyledRoot";
import { StyledRoot } from "@/admin/shared/ui";
import { config } from "@/admin/shared/constants";

import { SignInForm } from "./../../domains/SignInForm";
import { VerifyEmailForm } from "./../../domains/VerifyEmailForm";

export function SignIn() {
  const [token, setToken] = useState<string>();
  const [lastSignInInput, setLastSignInInput] = useState<{
    email?: string;
  }>();
  const { enqueueSnackbar } = useSnackbar();
  const client = useApolloClient();

  const onSignInSuccess = (data: any, input?: { email?: string }) => {
    enqueueSnackbar("Код подтверждения отправлен", {
      variant: "success",
    });

    setToken(data.signIn.token);

    if (input) {
      setLastSignInInput(input);
    }
  };

  const onVerifyEmailSuccess = (data: any) => {
    localStorage.setItem("token", data.verifySignIn.token);
    enqueueSnackbar("Вы успешно вошли в систему", { variant: "success" });
    client.resetStore();
  };

  const handleGoBack = () => {
    setToken(undefined);
    setLastSignInInput(undefined);
  };

  const getContactInfo = () => {
    if (lastSignInInput?.email) {
      return {
        contactType: "email" as const,
        contactInfo: lastSignInInput.email,
      };
    }

    return {
      contactType: "email" as const,
      contactInfo: "",
    };
  };

  const { contactType, contactInfo } = getContactInfo();

  return (
    <StyledRoot className={classes.root}>
      <div className={classes.form}>
        <Paper
          sx={{
            padding: 4,
            borderRadius: 2,
          }}
        >
          <Box sx={{ mb: 3, textAlign: "center" }}>
            <img
              src={config.logoUrl}
              alt="logo"
              style={{ maxWidth: "150px", marginBottom: "16px" }}
            />
            <Typography variant="h6">Вход в систему</Typography>
          </Box>

          {token ? (
            <VerifyEmailForm
              onCompleted={onVerifyEmailSuccess}
              token={token}
              // onResendCode={handleResendCode}
              onGoBack={handleGoBack}
              contactInfo={contactInfo}
              contactType={contactType}
            />
          ) : (
            <SignInForm onCompleted={onSignInSuccess} />
          )}
        </Paper>
      </div>
    </StyledRoot>
  );
}
